import { ContentTypeHandler } from '@resourceful-hono/core';
import { encode, decode } from 'cbor2';

export const CBOR_HANDLER: ContentTypeHandler = {
  decode(resource) {
    return resource.bytes().then(decode);
  },
  encode(data) {
    return encode(data);
  },
};

export enum CustomContentTypes {
  Cbor = 'application/cbor'
}